<template>
    <!-- 美加到门 -->
    <div  class="Booking">
    <TopNavigation  class="topNavigation"></TopNavigation>
    <div class=" typeArea">
        <div class="content">
            <div class="snqLo">
                <img src="https://www.speedyeta.com/user/img/zhLogo.3b9f693d.png" alt="">
            </div>
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="出口" name="first">
                    <Export  @from-child="receiveFromChildChu" :parMessage="canshu"   />
                </el-tab-pane>
                <el-tab-pane label="进口" name="second">
                    <Entrance  @from-child="receiveFromChildJin" :parMessage="canshu" />
                </el-tab-pane>

                <div class="info">
                    <Map :parent-object="activeName == 'first'?parentObjectChu:parentObjectJin" class="map" />
                    <div class="xinxi">
                        <div class="tit">
                            查询信息
                        </div>
                        <div class="comn">
                            <div><span>卸货港：</span>{{activeName == 'first'?dischargePlaceChu:dischargePlaceJin}}</div>
                            <div><span>目的地：</span>{{activeName == 'first'?dischargingPortChu:dischargingPortJin}}</div>
                            <div><span>总里程：</span>{{activeName == 'first'?mileageChu:mileageJin}}</div>
                        </div>
                    </div>
                </div>
            </el-tabs>
        </div>
    </div>
    <Bottom />
    </div>
</template>
    
<script>
import Bottom from '../HP/BottomPage.vue';
import TopNavigation from "../HP/TopNavigationB.vue";
import Export from "./ExportPage.vue";
import Entrance from "./EntrancePage.vue";
import Map from "./MapPage.vue";


export default {
    components:{
        Bottom,
        TopNavigation,
        Export,
        Entrance,
        Map

    },
    data() {
        return {
            activeName: 'first',
            parentObjectJin: {
                state_lon:'',
                state_lat:'',
                end_lon:'',
                end_lat:'',
                select:'',
            },
            // 卸货港
            dischargingPortJin:'--',
            // 卸货地
            dischargePlaceJin:'--',
            // 里程
            mileageJin:'--',
            childMessageJin:'',
            parentObjectChu: {
                state_lon:'',
                state_lat:'',
                end_lon:'',
                end_lat:'',
                select:'',
            },
            // 卸货港
            dischargingPortChu:'--',
            // 卸货地
            dischargePlaceChu:'--',
            // 里程
            mileageChu:'--',
            childMessageChu:'',
            // 页面跳转  带来的参数
            canshu:{}
        }
    },
    methods: {
        handleClick(tab, event) {
            console.log(tab, event);
        },
        receiveFromChildJin(message) {
        // 接收子组件传递的数据
            this.childMessageJin = message;

            this.parentObjectJin.state_lon= message.parentObject.state_lon
            this.parentObjectJin.state_lat= message.parentObject.state_lat
            this.parentObjectJin.end_lon= message.parentObject.end_lon
            this.parentObjectJin.end_lat= message.parentObject.end_lat
            this.parentObjectJin.select= message.parentObject.select

            this.dischargingPortJin=message.state_area_name
            this.dischargePlaceJin=message.end_port_name
            // this.mileageJin=message.distance+'mi'
            if(message.distance!='--'){
                this.mileageJin=message.distance+'mi'
            }
        },
        receiveFromChildChu(message) {
        // 接收子组件传递的数据
            this.childMessageChu = message;

            this.parentObjectChu.state_lon= message.parentObject.state_lon
            this.parentObjectChu.state_lat= message.parentObject.state_lat
            this.parentObjectChu.end_lon= message.parentObject.end_lon
            this.parentObjectChu.end_lat= message.parentObject.end_lat
            this.parentObjectChu.select= message.parentObject.select

            this.dischargingPortChu=message.state_area_name
            this.dischargePlaceChu=message.end_port_name
            if(message.distance!='--'){
                this.mileageChu=message.distance+'mi'
            }

        },
    },
    mounted(){
        this.canshu = this.$route.params
        if(this.canshu!=''){
            if(this.canshu.type==1){
                this.activeName="first"
                
            }else if(this.canshu.type==2){
                this.activeName="second"
            }

        }
    }
}
</script>
    
<style style lang="scss" scoped>
.topNavigation{
    height: 100PX;
    display: flex;
    justify-content: space-between;
    padding: 0 80px;
    background: #fff;
}

.Booking{
    background: #F9F9F9;
}
.typeArea{
    width: 1200px;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
}

.content{
    background: #fff;
    border-radius: 12px 12px 12px 12px;
    padding: 20px 32px 32px 32px;
    margin-top: 20px;
    margin-bottom: 20px;


    .snqLo{
        img{
            width: 150px;
        }
    }
    // .el-tabs{
    //     padding: 10px 32px;
    // }

    ::v-deep .el-tabs__item.is-active {
        color: #0073F5;//选中
    }
    
    ::v-deep .el-tabs__item:hover {
        color: #0073F5;//hover
        // cursor: pointer;
    }
    // 普通字体颜色
    ::v-deep .el-tabs__item {
        color: #606260;//悬浮
        // cursor: pointer;
        font-size: 18px;
    }

    // 下划线颜色
    ::v-deep .el-tabs__active-bar {
        background-color: #0073F5;
    }
}

.info{
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    .map{
        width: 800px;
        height: 480px;
        // background: pink;
    }

    .xinxi{
        width: 316px;
        height: 480px;
        background: #F9F9F9;
        border-radius: 0px 0px 0px 0px;
        padding: 20px;
        box-sizing: border-box;

        .tit{
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 16px;
            color: #000000;
            font-style: normal;
            text-transform: none;
            margin-bottom: 24px;
        }

        .comn{
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #0073F5;
            font-style: normal;
            text-transform: none;

            span{
                display: inline-block;
                width: 84px;
                height: 20px;
                font-size: 14px;
                color: #333333;
                text-align: right;
                margin-bottom: 12px;
            }
        }
    }
}
</style>